module.exports = __webpack_public_path__ + "img/install-android.c4d0687d.jpg";